// Sample data for the broker Analytics preview page. The page is a teaser: the charts
// are live (period toggle, theming) but the numbers are illustrative, not the user's.
//
// Shapes mirror the GET /analytics/company-analytics response (MetricData / PeriodBar)
// so the page can be pointed at the real endpoint later without reshaping the UI.

const toBars = (labels, values, changes = []) => labels.map((label, i) => ({ label, value: values[i], percentageChange: changes[i] ?? 0 }));

const WOW_LABELS = ["w21", "w22", "w23", "w24", "w25", "w26", "w27", "current"];
const WOW_CHANGES = [0, 0.8, -0.2, 2.1, 0, -1.1, -1.9, -2.6];

const MOM_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "current"];
const MOM_CHANGES = [0, -0.4, -0.5, 0.3, -0.6, -0.6, -1.3, -7.1];

export const sampleRevenuePerTruck = {
  WoW: {
    yTicks: [1300, 1500, 1700, 1900],
    metric: {
      currentCompanyValue: 1813,
      percentageVsMarket: 4,
      percentageVsTopPerforming: -12,
      companyBars: toBars(WOW_LABELS, [1884, 1876, 1868, 1872, 1861, 1849, 1830, 1655], WOW_CHANGES),
      marketBars: toBars(WOW_LABELS, [1742, 1786, 1726, 1730, 1711, 1683, 1620, 1667]),
      topPerformingBars: toBars(WOW_LABELS, [1817, 1833, 1770, 1845, 1845, 1809, 1734, 1616]),
    },
  },
  MoM: {
    yTicks: [6500, 7000, 7500, 8000],
    metric: {
      currentCompanyValue: 7150,
      percentageVsMarket: 3,
      percentageVsTopPerforming: -9,
      companyBars: toBars(MOM_LABELS, [7950, 7920, 7880, 7900, 7850, 7800, 7700, 7150], MOM_CHANGES),
      marketBars: toBars(MOM_LABELS, [7400, 7600, 7350, 7300, 7250, 7150, 6900, 7050]),
      topPerformingBars: toBars(MOM_LABELS, [7750, 7850, 7550, 7900, 7900, 7700, 7400, 7000]),
    },
  },
};
